import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

interface PermissionsState {
  read: boolean;
  write: boolean;
  patientBooker: boolean;
  loaded: boolean;
  globalAdmin: boolean;
  globalAdminLoaded: boolean;
}

const initialState: PermissionsState = {
  read: false,
  write: false,
  patientBooker: false,
  loaded: false,
  globalAdmin: false,
  globalAdminLoaded: false
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (
      state,
      action: PayloadAction<{ read: boolean; write: boolean; patientBooker: boolean }>
    ) => {
      state.read = action.payload.read;
      state.write = action.payload.write;
      state.patientBooker = action.payload.patientBooker;
      state.loaded = true;
    },
    clearPermissions: (state) => {
      state.read = false;
      state.write = false;
      state.patientBooker = false;
      state.loaded = false;
    },
    setGlobalAdmin: (state, action: PayloadAction<{ globalAdmin: boolean }>) => {
      state.globalAdmin = action.payload.globalAdmin;
      state.globalAdminLoaded = true;
    }
  }
});

export const { setPermissions, clearPermissions, setGlobalAdmin } = permissionsSlice.actions;
export const selectCanWrite = (state: RootState) =>
  state.permissionsSlice.loaded && state.permissionsSlice.write;
// Assigning or removing a patient from an intervention group requires only the
// patient-booker permission. Moving intervention groups around is a separate
// capability gated by `selectCanWrite`.
export const selectCanBookPatient = (state: RootState) =>
  state.permissionsSlice.loaded && state.permissionsSlice.patientBooker;
export const selectIsGlobalAdmin = (state: RootState) => state.permissionsSlice.globalAdmin;
export const selectGlobalAdminLoaded = (state: RootState) =>
  state.permissionsSlice.globalAdminLoaded;
export default permissionsSlice.reducer;
